var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Helmet = require('react-helmet');
var Loader = require('react-loader');
var Link = require('react-router').Link;
var Video = require( './layout/video.jsx' );
var ContentMarkDown = require( './layout/contentMarkDown.jsx' );
var BackButton = require('../../components/backButton.jsx');
var ContentEditor = require('./layout/editor.jsx');
var PageEditor = require('./layout/pageEditor.jsx');
var VideoEditor = require('./layout/videoEditor.jsx');

var BodyPart = createReactClass({
	mixins: [PureRenderMixin],

    getInitialState: function () {
        return {
          editMode: false,
        };
    },

    componentDidMount: function() {
        if (this.props.params.name === 'new') {
            this.setState(Object.assign({}, this.state, {editMode: true}));
            this.props.setBodyPart({ isActive: true, meta: {}, video: {} });
        } else {
            this.props.fetchBodyPartIfNeeded(this.props.params.name);
        }
    },

    hasDataLoaded: function(){
        if (this.props.params.name === 'new') { return true };
        return !!(this.props.bodyPart.items && this.props.bodyPart.items.friendlyUrl === this.props.params.name);
    },

    openEditor: function(){
        this.setState(Object.assign({}, this.state, {editMode: true}));
    },

    closeEditor: function(){
        this.setState(Object.assign({}, this.state, {editMode: false}));
    },

    submitForm: function(e, isNew) {
        var token = this.props.auth.token;
        var bodyPart = this.props.bodyPart.items;

        // Check for friendlyUrl change
        if (bodyPart.friendlyUrl !== bodyPart.newFriendlyUrl) {
            bodyPart.friendlyUrl = bodyPart.newFriendlyUrl;
            delete bodyPart.newFriendlyUrl;
            this.props.setBodyPart(bodyPart);
        }

        if (isNew) {
            this.props.createBodyPart(bodyPart, token);
        } else {
            this.props.updateBodyPart(bodyPart, token);
        }

        this.closeEditor();
    },

    handleChange: function(event, subfield) {
        var bodyPart = this.props.bodyPart.items;

        if (event.target) {
          const inputValue = (event.target.type === 'checkbox') ? event.target.checked : event.target.value;
          if (subfield) {
            bodyPart[subfield][event.target.name] = inputValue;
          } else {
            bodyPart[event.target.name] = inputValue;
          }
        }

        this.props.setBodyPart(bodyPart);
    },

    handleEditorChange: function(fieldName, content) {
        var bodyPart = this.props.bodyPart.items;

        if (fieldName && content) {
            bodyPart[fieldName] = content;
        }

        this.props.setBodyPart(bodyPart);
    },

    getContent: function(){
        const { isAdmin = false } = this.props.auth;
        var bodyPart = this.props.bodyPart.items;
        var isNew = this.props.params.name === 'new';

        var children = [
            <Helmet
                title={(bodyPart.meta && bodyPart.meta.title) || bodyPart.title}
                meta={[{
                    name: 'description',
                    content: (bodyPart.meta && bodyPart.meta.description) || bodyPart.description
                }]}
                key={0} />,
			<div className="content-header-wrapper" key={'content-header-wrapper'}>
				<div className="row content-header">
					<div className="small-12 medium-3 column back show-for-medium">
						<Link to="/education" onClick={this.props.setActiveEducationToggle.bind(null, 'BODYPARTS')}><span className="ion-ios-arrow-thin-left"></span> back to All Systems</Link>
					</div>
					<div className="small-12 medium-6 column title">
						<h1>{bodyPart.title}</h1>
					</div>
					<div className="small-12 medium-3 column"></div>
				</div>
			</div>,
			<BackButton key="back-button" />,
            <div key={1}>
                {bodyPart.video && !this.state.editMode &&
                <div id="hero-container">
                    <div id="hero">
                        <div className="row">
                            <div className="medium-7 small-12 column medium-centered">
                                <Video gender={this.props.auth.user.sex} video={bodyPart.video} />
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>,
            <section id="information" key={2}>
                <div className="row">
                    {this.state.editMode ?
                        <div>
                            <div className="topic small-12 column">
                                {(isNew) ? <h2>Add new body part</h2> : <h3>Page content</h3> }
                                <ContentEditor payload={bodyPart.education} onChange={(content) => this.handleEditorChange('education', content)} />
                                <br />
                                <PageEditor
                                    section="bodyparts"
                                    isActive={bodyPart.isActive}
                                    friendlyUrl={bodyPart.friendlyUrl}
                                    title={bodyPart.title}
                                    displayName={bodyPart.displayName}
                                    meta={bodyPart.meta}
                                    handleChange={this.handleChange} />
                                <VideoEditor
                                    video={bodyPart.video}
                                    videoFieldName="video"
                                    handleChange={this.handleChange} />
                            </div>
                            <div className="small-12 column">
                                <div className="action-field float-right">
                                    <button className="alert button" type="submit" onClick={this.closeEditor}>Cancel</button>&nbsp;&nbsp;
                                    <button className="blue button" type="submit" onClick={(e) => this.submitForm(e, isNew)}>{(isNew) ? "Create new" : "Save changes"}</button>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="topic editor-area small-12 column">
                            <aside className="editor-actions">
                                <ul className="menu">
                                    {(isAdmin) ?
                                        <li><a className="" title="Edit page" onClick={this.openEditor}>Edit page</a></li> : null}
                                </ul>
                            </aside>
                            <h1>About {bodyPart.title}</h1>
                            <ContentMarkDown payload={bodyPart.education || ''} />
                        </div>
                    }
                </div>
            </section>
        ];

        var content = (
            <Loader loaded={this.hasDataLoaded()}>
                {children}
            </Loader>
        );

        if(this.hasDataLoaded()){
            content = children;
        }

        return content;
    },

    render: function () {
        return (
            <div className="content">
                {this.getContent()}
            </div>
        );
    }
});

module.exports = BodyPart;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/bodypart.jsx